import { Component, ElementRef, HostListener, Input, OnInit, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { PreferencesService } from '../../../../services/preferences.service';
import { DateHelper } from '../../../../common/helpers/date-helper';
import { FTDate } from '../../../../common/models/FTDate';
import { MultiMediaBasicInfo } from '../../../../common/models/MultiMediaBasicInfo';
import { first } from 'rxjs/operators';
import { CustomError } from 'src/app/common/helpers/custom-error';
import { TooltipPosition, DateTooltipPlace } from 'src/app/common/enums/enums';
import { GenealogyDate } from 'src/app/common/helpers/date/genealogy-date';
import { GenealogyDateRange } from 'src/app/common/helpers/date/genealogy-date-range';

@Component({
    selector: 'app-date-input-componnent',
    templateUrl: './date-input-componnent.component.html',
    styleUrls: ['./date-input-componnent.component.scss'],
    standalone: false
})
export class DateInputComponnentComponent {
  @Input() ftDateObject: FTDate;
  @Output() formattedDateModel = new EventEmitter<any>();
  @Input() fieldEnabled: boolean;
  @Input() tooltipPosition: TooltipPosition;
  @Input() popupWidth: string;
  @Input() dateTooltipPlace: DateTooltipPlace;
  @Input() isExpand?: boolean;


  dateString: string;
  showWarning: boolean = false;
  // tooltipPosition: TooltipPosition;

  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private preferenceService: PreferencesService,
    private dateHelper: DateHelper
  ) {
    this.el = this.elementRef.nativeElement;
    // this.tooltipPosition = TooltipPosition.Bottom;
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'ftDateObject': {
            this.dateString = (this.ftDateObject && this.ftDateObject.formattedText) ? this.ftDateObject.formattedText : "";
            if (this.ftDateObject)
              this.dateByActiveCulture(this.ftDateObject);
            else {
              this.showWarning = false;
            }
          }
          case 'fieldEnabled': {
            this.fieldEnabled = this.fieldEnabled;
          }
        }
      }
    }
  }

  dateByActiveCulture(ftdate: FTDate) {
    let genealogyDateObj;

    //Date
    if (ftdate.genealogyDate) {
      genealogyDateObj = new GenealogyDate(ftdate.genealogyDate.originalStr, ftdate.genealogyDate.culture);
      Object.assign(genealogyDateObj, ftdate.genealogyDate);
    }

    //DateRange
    if (ftdate.genealogyDateRange) {
      genealogyDateObj = new GenealogyDateRange(ftdate.genealogyDateRange.originalStr, ftdate.genealogyDateRange.from,
        ftdate.genealogyDateRange.to, ftdate.genealogyDateRange.rangeType, ftdate.genealogyDateRange.rangeStr);
    }

    let formattedDate;
    if (genealogyDateObj) {
      formattedDate = this.dateHelper.formatDate(genealogyDateObj)
      if (formattedDate) {
        this.dateString = formattedDate;
      }
    }
    else
      this.showWarning = true;

    return formattedDate;
  }

  //@HostListener("blur", ["$event.target.value"])
  onBlur() {
    this.showWarning = false;
    let dateHelper = new DateHelper(this.preferenceService);
    if (this.dateString) {
      let formattedDate = dateHelper.validateAndFormat(this.dateString);
      this.showWarning = !formattedDate.isValidDate;
      this.formattedDateModel.emit(formattedDate);
      return;
    }
    this.formattedDateModel.emit(this.dateString);
  }
}

